export default "__VITE_ASSET__DqjsxYqh__"